import React from 'react';
import {AppleSocialButton} from 'react-native-social-buttons';

export default function AppleSignInButton({onPress}) {
  return <AppleSocialButton onPress={() => onPress()} />;
}
